module.exports = __webpack_public_path__ + "static/media/timo-geiser.f0b4ea36.jpg";